/**
 * Shared localized-copy helpers for the auth forms.
 *
 * Keeping copy resolution in a plain module (not inside the form components)
 * keeps the components' JSX free of `||`-fallback branching, which otherwise
 * pushes their cyclomatic complexity far past the lint threshold.
 */

/** Coalesce a possibly-empty localized string to its English fallback. */
export function orDefault(value: string | undefined, fallback: string): string {
  return value && value.length > 0 ? value : fallback;
}
